"use strict";

export function init() {
    $('.js-open-modal-on-load').first().modal('show');
}